import axios from 'axios';
import Split from '../split';
import { getUnreadMonthlyReportsCountQuery } from './queries';

const getMonthlyReportsUnreadCount = (id) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const query = getUnreadMonthlyReportsCountQuery({ id, useExpress });
        const request = axios.get(query);

        request
            .then((response) => {
                resolve({ success: true, unreadCount: response.data.count });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getMonthlyReportsUnreadCount;
